import React from 'react';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../types';
import * as helper from '../../../helper/html-helper';
import styles from './warningInfromation.scss';
import { WarningShutterNotice } from '../../../stores/types';

export const WarningInformation = inject('store')(
    observer(({ store }: IInjectedProps) => {
        if (!store)
            return null;

        const warningIcons = store.dataStore.mainStore.warningNoticeModule.icons;
        const warnings = store.dataStore.mainStore.warningNoticeModule.warningNotices;

        function getNoticeHeader(notice: WarningShutterNotice): string {
            let localizationKey;
            switch (notice.readableId) {
                case 'gfh_p-saetze': 
                    localizationKey = store?.localization.generalL10n.safetyInstructions;
                    break;
                case 'gfh_h-saetze':
                    localizationKey = store?.localization.generalL10n.hazardWarnings;
                    break;
                case 'gfh_euh-saetze':
                    localizationKey = store?.localization.generalL10n.specialHazards;
                    break;
                default:
                    // unsupported readableId
            }

            return localizationKey || '';
        }

        return (
            <>
                <div className={styles.warning_shutter}>
                    <div className={styles.warning_shutter_icons_container}>
                        { warningIcons.map((icon, i) => 
                            <img key={icon.altText + '_' + i}
                                className={styles.warning_shutter_icon}
                                alt={helper.decodeHTML(icon.altText) ?? ''}
                                src={icon.imageUrl} />
                        )}
                    </div>

                    <div className={styles.warning_shutter_notices_container}>
                        { warnings.map((notice) => {
                            return (
                                <div key={notice.readableId} className={styles.warning_shutter_notice}>
                                    <div className={styles.warning_shutter_notice_header}>{getNoticeHeader(notice)}</div>

                                    <ul className={styles.warning_shutter_notice_list}>
                                        { notice.valuesTexts.map((noticeText, i) => 
                                            <li key={notice.readableId + '_notice_text_' + i}>{noticeText}</li>
                                        )}
                                    </ul>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    }));
